<template>
    <page-title
        title="題材別評価（一覧）"
        icon="bi-bricks"
        :title_sub_1="is_muji ? '無地' : ''"
        :backTo="{ name: is_muji ? 'PageRepocraftMujiHome' : 'PageRepocraftHome' }"
    >
    </page-title>

    <inline-loader v-if="loading"></inline-loader>

    <template v-else>
        <summary-box title="対象">
            <summary-box-row
                title=""
                :text="`${Grade.getWhereSchoolType(school.school_type, school_class.grade)} ${school_class.class_name_display}（${school_class.year}年度）`"
            ></summary-box-row>
        </summary-box>

        <inline-loader v-if="loading_subjects"></inline-loader>
        <template v-else>
            <template v-if="planned_subjects.length">
                <summary-box-section title="題材" class="mb-4">
                    <summary-box-row>
                        <div class="col-20 col-md-15 col-lg-12">
                            <form-select
                                v-model="subject_id"
                                :options = planned_subjects
                                option_key = "planned_subject_id"
                                option_label = "subject_name"
                                :disabled="subject_disabled"
                                @change="setActive()"
                            ></form-select>
                        </div>
                    </summary-box-row>
                </summary-box-section>

                <inline-loader v-if="loading_table"></inline-loader>
                <template v-else>
                    <template v-if="subject_evaluations.length">
                        <table-normal>
                            <colgroup>
                                <col class="col-1">
                                <col class="col-md-4">
                                <col class="col-md-3">
                                <col class="col-md-3">
                                <col class="col-md-3">
                                <col class="col-md-3">
                                <col class="col-md-3">
                                <col class="col-md-2">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th rowspan="2"></th>
                                    <th rowspan="2">{{ $student_label() }}</th>
                                    <th colspan="5">評価</th>
                                    <th rowspan="2">最終回</th>
                                </tr>
                                <tr>
                                    <th :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_1)}">知識</th>
                                    <th :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_2)}">技能</th>
                                    <th :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_3)}">発想・構想</th>
                                    <th :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_4)}">鑑賞</th>
                                    <th :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_5)}">主体的</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(evaluation, index) in subject_evaluations" :key="index">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ evaluation.account_user.student_name }}</td>
                                    <td class="text-end" :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_1)}">{{ evaluation.subject_evaluation.evaluation_score_1 }}</td>
                                    <td class="text-end" :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_2)}">{{ evaluation.subject_evaluation.evaluation_score_2 }}</td>
                                    <td class="text-end" :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_3)}">{{ evaluation.subject_evaluation.evaluation_score_3 }}</td>
                                    <td class="text-end" :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_4)}">{{ evaluation.subject_evaluation.evaluation_score_4 }}</td>
                                    <td class="text-end" :class="{disabled: $helper.isNud(active_planned_subject.evaluation_item_5)}">{{ evaluation.subject_evaluation.evaluation_score_5 }}</td>
                                    <td class="text-center">
                                        <!-- ワークシートのうち最終回のワークシートにリンク（配布されていない場合もあり！） -->
                                        <router-link
                                            :to="{
                                                name: is_muji ? 'PageRepocraftMujiWorksheetStudent' : 'PageRepocraftWorksheetStudent',
                                                params: {
                                                    worksheet: active_planned_subject.worksheets[active_planned_subject.worksheets.length - 1].planned_worksheet_id,
                                                    account_user: evaluation.account_user.account_user_id
                                                }
                                            }"
                                            v-if="active_planned_subject.worksheets.length"
                                        >
                                            <button-dom-show></button-dom-show>
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table-normal>
                    </template>
                    <alert-no-record v-else></alert-no-record>
                </template>
            </template>
            <alert-no-record v-else></alert-no-record>
        </template>
    </template>
</template>

<script>
import AccountUser from '@/shared/models/entities/account-user';
import School from '@/shared/models/entities/school';
import SchoolClass from '@/shared/models/entities/school-class';
import PlannedSubject from '@/shared/models/entities/repocraft/planned-subject';
import SubjectEvaluation from '@/shared/models/entities/repocraft/subject-evaluation';
import Grade from '@/shared/models/enums/grade'
import PageTitle from '@/shared/components/design/PageTitle';
import ButtonDomShow from '@/shared/components/design/buttons/ButtonDomShow.vue';
import FormSelect from '@/shared/components/form/FormSelect';
import SummaryBox from '@/shared/components/design/SummaryBox';
import SummaryBoxSection from '@/shared/components/design/SummaryBoxSection';
import SummaryBoxRow from '@/shared/components/design/SummaryBoxRow';
import TableNormal from '@/shared/components/design/TableNormal';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import InlineLoader from '@/shared/components/tool/InlineLoader';

export default {
    name: 'PageRepocraftSubjectAdd',
    components: {
        PageTitle,
        ButtonDomShow,
        FormSelect,
        SummaryBox,
        SummaryBoxSection,
        SummaryBoxRow,
        TableNormal,
        AlertNoRecord,
        InlineLoader
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            is_muji: this.$route.meta?.is_muji ?? false, // レポクラフト無地判定
            app_key: this.$route.meta?.is_muji ? 'repocraft_muji' : 'repocraft', //アプリ名取得

            year: null,
            grade: null,
            class: null,
            subject_id: null,

            //ログイン先生の学校情報
            school: new School(this.$store.state.school.auth.school),

            school_class: new SchoolClass(),
            active_planned_subject: new PlannedSubject(),

            planned_subjects: [],
            account_users: [],
            subject_evaluations: [],

            //enum
            Grade,

            subject_disabled: false,
            loading: false,
            loading_subjects: false,
            loading_table: 0,
        }
    },
    mounted() {
        this.year = parseInt(this.$route.params.year, 10);
        this.grade = parseInt(this.$route.params.grade, 10);
        this.class = parseInt(this.$route.params.class, 10);

        this.getClassInfo();
        this.getSubjectList();
    },
    methods: {
        //特定クラス情報の取得
        getClassInfo() {
            this.loading = true;
            this.$http.get(`school/${this.app_key}/year/${this.year}/grade/${this.grade}/class/${this.class}`)
            .then(response => {
                if (this.$helper.isNud(response.data.school_class_id)) {
                    //存在しなければリダイレクト
                    this.showErrorMessage('存在しないクラスです');
                    this.$router.push({name: this.is_muji ? 'PageRepocraftMujiHome': 'PageRepocraftHome'});
                }
                this.school_class = new SchoolClass(response.data);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        //実施題材一覧の取得
        getSubjectList() {
            this.loading_subjects = true;
            this.planned_subjects = [];
            this.$http.get(`school/${this.app_key}/year/${this.year}/grade/${this.grade}/subject`)
            .then(response => {
                for (let subject of response.data) {
                    this.planned_subjects.push(new PlannedSubject(subject));
                }
                if (this.planned_subjects.length) {
                    if (this.$route.query.subject && this.planned_subjects.some((subject) => { return (subject.planned_subject_id == this.$route.query.subject);})) {
                        //パラメータ付きで遷移した場合
                        this.subject_id = this.$route.query.subject;
                    } else {
                        //1件目をセット
                        this.subject_id = this.planned_subjects[0].planned_subject_id;
                    }
                    this.getSubject();
                }
            })
            .catch(() => {
                //404エラー 存在しなければリダイレクト TODO: どこに？
                this.$router.push({name: this.is_muji ? 'PageRepocraftMujiHome' : 'PageRepocraftHome'});
            })
            .finally(() => {
                this.loading_subjects = false;
            });
        },
        //選択された題材を取得
        getSubject() {
            this.loading_table++;
            this.subject_disabled = true;
            this.$http.get(`school/${this.app_key}/year/${this.year}/grade/${this.grade}/subject/${this.subject_id}`)
            .then((response) => {
                this.active_planned_subject = new PlannedSubject(response.data);
                this.getEvaluation();
            })
            .finally(() => {
                this.loading_table--;
            });
        },
        //クラス別児童評価一覧の取得
        getEvaluation() {
            this.loading_table++;

            this.subject_evaluations = [];
            this.$http.get(`/school/${this.app_key}/evaluation/subject/${this.subject_id}/class/${this.class}`)
            .then(response => {
                //児童ごと評価リスト取得
                for (let i = 0; i < response.data.length; i++) {
                    this.subject_evaluations[i] = {};
                    this.subject_evaluations[i].account_user = new AccountUser(response.data[i].account_user);
                    this.subject_evaluations[i].subject_evaluation = new SubjectEvaluation(response.data[i].subject_evaluation);
                }
            })
            .finally(() => {
                this.subject_disabled = false;
                this.loading_table--;
            });
        },
        //選択で切り替えられた題材と評価を取得
        setActive() {
            this.getSubject();
        },
    },
}
</script>

<style scoped>
    .disabled {background-color: #ececec !important;}
</style>
<style>
    .title-sub-1 {border-color: #198754 !important;}
</style>
